/** Account sections (W09), in order: Profile · Devices · Payouts · Notifications · Privacy · Work types. `work` is the
 * kinds of work you do (the old /paths pages). There are no agents or API tokens of your own (agents are made only in
 * ops); the old /account/agents address shows the profile. */
export const ACCOUNT_TABS = ['profile', 'devices', 'payouts', 'notifications', 'privacy', 'work'] as const
export type AccountTab = (typeof ACCOUNT_TABS)[number]
